
import React, { useState, useContext, createContext, useEffect } from "react";
import { toast } from 'react-toastify';
import { criaColunasNegociadas, criaColunasTaxas } from '../components/Columns';
import { carregaCobrancas, carregaNegociadas, carregaParcelasCartao } from '../services/GetPrivateInfo';
import { formatCurrency } from "../utils/FormatCurrency";
import { useAuth } from './AuthContext';

const PrivateInfoContext = createContext({});

function PrivateInfo({children}){
    const { user_id, provider_id } = useAuth();
    const [infoCobrancas,setInfoCobrancas] = useState([]);
    const [tableCobrancas,setTableCobrancas] = useState([]);
    const [dynamicColumns,setDynamicColumns] = useState([]);
    const [negociadasColumns,setNegociadasColumns] = useState([]);
    const [parcelasOpcoes,setParcelasOpcoes] = useState([]);
    const [valorOriginal,setValorOriginal] = useState(0);
    const [valorBoleto,setValorBoleto] = useState(0);
    const [tableNegociacao,setTableNegociacao] = useState([]);
    const [taxaBoleto] = useState(4.9);
    const [cartaoBandeira,setCartaoBandeira] = useState('mastercard')
    const [cartaoNumero,setCartaoNumero] = useState('');
    const [page,setPage] = useState(0);
    const [first,setFirst] = useState(0);
    const [reload,setReload] = useState(false);
    const [loading,setLoading] = useState(false)

    function formataCobrancas(data){
        if(data){
            setInfoCobrancas(data);
            setTableCobrancas(data.cobrancas);
            ValorAPagar(data.original_total);
            setDynamicColumns(criaColunasTaxas);
        }
    }

    function formataBoletoInfo(data){
        if(data){
        setTableNegociacao(data);
        }
        setNegociadasColumns(criaColunasNegociadas);
    }

    function formataParcelas(data){
        const parcelasFormatadas =
                data.map((parcela)=>({
                    label:`${parcela.numero_parcela}x de ${formatCurrency(parcela.valor_parcela)}`,
                    values: {
                        qtd_parcelas: Number(parcela.numero_parcela),
                        value: Number(parcela.valor_parcela),
                    }
                }))
        setParcelasOpcoes(parcelasFormatadas)
    }

    
    function ValorAPagar(total){
        setValorOriginal(total)
        setValorBoleto(total+taxaBoleto)
        parcelasCartao(total)
      //  calculaFeePague(total)
    }

    // function calculaFeePague(original){
    //     const valorTotal = ((original+2.9)/0.99)+5;
    //     const valorFeePague = Number((valorTotal - original).toFixed(2)); 
    //     if(original === 0)
    //     setFeePague(0);
    //     else
    //     setFeePague(valorFeePague);
    // }

    const parcelasCartao = async(valor) =>{
        try {
            const parcelas = await carregaParcelasCartao(valor,cartaoBandeira)
            formataParcelas(parcelas)
        } catch (error) {
            console.log(error)
        }
    }

    const carregaInfo = async() =>{
        setLoading(true)
        try {
            const cobrancasData = await carregaCobrancas(provider_id,user_id,10,page)            
            formataCobrancas(cobrancasData)
        } catch (error) {
            console.log(error)
            toast.error('Erro ao carregar as taxas!')
        }
        try {
            const boletosData = await carregaNegociadas(user_id,provider_id)
            formataBoletoInfo(boletosData)
        } catch(error){
            console.log(error)
            toast.error('Erro ao carregar informações de negociação')
        }
        setLoading(false)
    }
    
    useEffect(()=>{
        carregaInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[reload])
    
    return (
      <PrivateInfoContext.Provider
        value={{
            infoCobrancas,
            tableCobrancas,
            dynamicColumns,
            negociadasColumns,
            parcelasOpcoes,
            valorOriginal,
            valorBoleto,
            tableNegociacao,
            taxaBoleto,
            cartaoBandeira,
            cartaoNumero,
            loading,
            page,
            first,
            setFirst,
            setPage,
            setReload,
            setLoading,
            setCartaoBandeira,
            setCartaoNumero
        }}
      >
        {children}
      </PrivateInfoContext.Provider>
        )
    }
    
function usePrivate(){
        const context = useContext(PrivateInfoContext);
        return context;
    }
    
export {usePrivate,PrivateInfo}    


